"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mutil_pinyin_dict;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var mutil_pinyin_dict = exports.mutil_pinyin_dict = (_mutil_pinyin_dict = {
    "阿訇": "ā,hōng",
    "阿罗汉": "ā,luó,hàn",
    "阿木林": "ā,mù,lín",
    "阿姨": "ā,yí",
    "阿谀": "ē,yú",
    "阿附": "ē,fù",
    "阿胶": "ē,jiāo",
    "阿弥陀佛": "ē,mí,tuó,fó",
    "了解": "liǎo,jiě",
    "了如指掌": "liǎo,rú,zhǐ,zhǎng",
    "一目了然": "yī,mù,liǎo,rán",
    "俩人": "liǎ,rén",
    "你们俩": "nǐ,mēn,liǎ",
    "我们俩": "wǒ,mēn,liǎ",
    "他们俩": "tā,mēn,liǎ",
    "子弹": "zǐ,dàn",
    "炮弹": "pào,dàn",
    "弹药": "dàn,yào",
    "调查": "diào,chá",
    "声调": "shēng,diào",
    "音乐": "yīn,yuè",
    "乐曲": "yuè,qǔ",
    "乐器": "yuè,qì",
    "乐谱": "yuè,pǔ",
    "缝隙": "fèng,xì",
    "胸脯": "xiōng,pú",
    "裂缝": "liè,fèng",
    "干部": "gàn,bù",
    "才干": "cái,gàn",
    "干劲": "gàn,jìn",
    "骨干": "gǔ,gàn",
    "爱好": "ài,hào",
    "恶心": "ě,xīn",
    "挨个": "āi,gè",
    "挨近": "āi,jìn",
    "挨打": "ái,dǎ",
    "挨说": "ái,shuō",
    "拗口": "ào,kǒu",
    "执拗": "zhí,niù",
    "翅膀": "chì,bǎng",
    "蛤蚌": "gé,bàng",
    "蚌埠": "bèng,bù",
    "薄弱": "bó,ruò",
    "稀薄": "xī,bó",
    "单薄": "dān,bó",
    "淡薄": "dàn,bó",
    "尖嘴薄舌": "jiān,zuǐ,bó,shé",
    "厚薄": "hòu,báo",
    "碉堡": "diāo,bǎo",
    "堡垒": "bǎo,lěi",
    "堡子": "bǔ,zi",
    "吴堡": "wú,bǔ",
    "瓦窑堡": "wǎ,yáo,bǔ",
    "柴沟堡": "chái,gōu,bǔ",
    "十里堡": "shí,lǐ,pù",
    "暴露": "bào,lòu",
    "一曝十寒": "yī,pù,shí,hán",
    "背脊": "bèi,jǐ",
    "背景": "bèi,jǐng",
    "背静": "bèi,jìng",
    "手臂": "shǒu,bì",
    "臂膀": "bì,bǎng",
    "胳臂": "gē,bei",
    "复辟": "fù,bì",
    "裨益": "bì,yì",
    "裨补": "bì,bǔ",
    "骠骑": "piào,qí",
    "骠勇": "piào,yǒng",
    "屏除": "bǐng,chú",
    "屏气": "bǐng,qì",
    "屏弃": "bǐng,qì",
    "屏息": "bǐng,xī",
    "屏幕": "píng,mù",
    "屏风": "píng,fēng",
    "屏藩": "píng,fān",
    "剥削": "bō,xuē",
    "淡泊": "dàn,bó",
    "漂泊": "piāo,bó",
    "停泊": "tíng,bó",
    "湖泊": "hú,pō",
    "血泊": "xuè,pō",
    "大伯": "dà,bó",
    "伯伯": "bó,bo",
    "老伯": "lǎo,bó",
    "大伯子": "dà,bǎi,zǐ",
    "颠簸": "diān,bǒ",
    "簸箕": "bò,ji",
    "胳膊": "gē,bo",
    "萝卜": "luó,bo",
    "矿藏": "kuàng,cáng",
    "宝藏": "bǎo,zàng",
    "不差累黍": "bù,chà,lěi,shǔ",
    "不差": "bù,chà",
    "偏差": "piān,chā",
    "色差": "sè,chā",
    "差别": "chā,bié",
    "视差": "shì,chā",
    "误差": "wù,chā",
    "电势差": "diàn,shì,chā",
    "一念之差": "yī,niàn,zhī,chā",
    "差池": "chā,chí",
    "言差语错": "yán,chā,yǔ,cuò",
    "一差二错": "yī,chā,èr,cuò",
    "阴差阳错": "yīn,chā,yáng,cuò",
    "差等": "chā,děng",
    "差额": "chā,é",
    "差价": "chā,jià",
    "差强人意": "chā,qiǎng,rén,yì",
    "差数": "chā,shù",
    "差异": "chā,yì",
    "差不多": "chà,bù,duō",
    "差不离": "chà,bù,lí",
    "差点": "chà,diǎn",
    "参差": "cēn,cī",
    "颤动": "chàn,dòng",
    "发颤": "fā,chàn",
    "战栗": "zhàn,lì",
    "颤栗": "zhàn,lì",
    "打颤": "dǎ,zhàn",
    "场合": "chǎng,hé",
    "场所": "chǎng,suǒ",
    "冷场": "lěng,chǎng",
    "捧场": "pěng,chǎng",
    "外场": "wài,cháng",
    "圩场": "xū,cháng",
    "场院": "cháng,yuàn",
    "一场雨": "yī,cháng,yǔ",
    "排场": "pái,chang",
    "嘲讽": "cháo,fěng",
    "嘲骂": "cháo,mà",
    "嘲笑": "cháo,xiào",
    "安步当车": "ān,bù,dāng,chē",
    "杯水车薪": "bēi,shuǐ,chē,xīn",
    "闭门造车": "bì,mén,zào,chē",
    "螳臂当车": "táng,bì,dāng,chē",
    "称心": "chèn,xīn",
    "称意": "chēng,yì",
    "称职": "chèn,zhí",
    "对称": "duì,chèn",
    "相称": "xiāng,chèn",
    "包乘制": "bāo,chéng,zhì",
    "乘便": "chéng,biàn",
    "乘风破浪": "chéng,fēng,pò,làng",
    "乘客": "chéng,kè",
    "乘势": "chéng,shì",
    "乘兴": "chéng,xìng",
    "澄清": "chéng,qīng",
    "尺寸": "chǐ,cùn",
    "尺头": "chǐ,tóu",
    "冲床": "chòng,chuáng",
    "冲模": "chòng,mú",
    "装模作样": "zhuāng,mú,zuò,yàng",
    "遗臭万年": "yí,chòu,wàn,nián",
    "粘贴": "zhān,tiē",
    "校舍": "xiào,shè",
    "数学": "shù,xué",
    "数字": "shù,zì",
    "数目": "shù,mù",
    "退避三舍": "tuì,bì,sān,shè",
    "乳臭": "rǔ,xiù",
    "铜臭": "tóng,xiù",
    "处罚": "chǔ,fá",
    "处分": "chǔ,fèn",
    "处决": "chǔ,jué",
    "处理": "chǔ,lǐ",
    "处女": "chǔ,nǚ",
    "处置": "chǔ,zhì",
    "畜力": "chù,lì",
    "家畜": "jiā,chù",
    "牲畜": "shēng,chù",
    "幼畜": "yòu,chù",
    "畜产": "xù,chǎn",
    "畜牧": "xù,mù",
    "畜养": "xù,yǎng",
    "草创": "cǎo,chuàng",
    "创举": "chuàng,jǔ",
    "首创": "shǒu,chuàng",
    "创造": "chuàng,zào",
    "创作": "chuàng,zuò",
    "创伤": "chuāng,shāng",
    "重创": "zhòng,chuāng",
    "绰绰有余": "chuò,chuò,yǒu,yú",
    "宽绰": "kuān,chuo",
    "枞树": "cōng,shù",
    "枞阳": "zōng,yáng",
    "万头攒动": "wàn,tóu,cuán,dòng",
    "万箭攒心": "wàn,jiàn,cuán,xīn",
    "报答": "bào,dá",
    "答复": "dá,fù",
    "搭理": "dā,lǐ",
    "答应": "dā,yìng",
    "苏打": "sū,dá",
    "大夫": "dài,fū",
    "大王": "dài,wáng",
    "大城": "dài,chéng",
    "逮捕": "dài,bǔ",
    "当地": "dāng,dì",
    "当年": "dāng,nián",
    "当日": "dāng,rì",
    "当天": "dàng,tiān",
    "当时": "dāng,shí",
    "适当": "shì,dàng",
    "颠倒": "diān,dǎo",
    "颠三倒四": "diān,sān,dǎo,sì",
    "倾箱倒箧": "qīng,xiāng,dǎo,qiè",
    "排山倒海": "pái,shān,dǎo,hǎi",
    "倒板": "dǎo,bǎn",
    "倒仓": "dǎo,cāng",
    "倒嚼": "dǎo,jiào",
    "倒嗓": "dǎo,sǎng",
    "倒戈": "dǎo,gē",
    "潦倒": "liáo,dǎo",
    "提防": "dī,fáng",
    "的确": "dí,què",
    "打点": "dǎ,diǎn",
    "都市": "dū,shì",
    "首都": "shǒu,dū",
    "大都": "dà,dū",
    "撺掇": "cuān,duo",
    "掂掇": "diān,duo",
    "忖度": "cǔn,duó",
    "度德量力": "duó,dé,liàng,lì",
    "理发": "lǐ,fà",
    "脱发": "tuō,fà",
    "结发": "jié,fà",
    "牌坊": "pái,fāng",
    "坊巷": "fāng,xiàng",
    "粉坊": "fěn,fáng",
    "磨坊": "mò,fáng",
    "碾坊": "niǎn,fáng",
    "染坊": "rǎn,fáng",
    "油坊": "yóu,fáng",
    "谷坊": "gǔ,fáng",
    "葛藤": "gé,téng",
    "葛布": "gé,bù",
    "瓜葛": "guā,gé",
    "补给": "bǔ,jǐ",
    "供给": "gōng,jǐ",
    "给予": "jǐ,yǔ",
    "配给": "pèi,jǐ",
    "自给自足": "zì,jǐ,zì,zú",
    "重荷": "zhòng,hè",
    "负荷": "fù,hè",
    "恐吓": "kǒng,hè",
    "威吓": "wēi,hè",
    "系鞋带": "jì,xié,dài",
    "系绳子": "jì,shéng,zǐ",
    "放假": "fàng,jià",
    "假期": "jià,qī",
    "请假": "qǐng,jià",
    "暑假": "shǔ,jià",
    "五更": "wǔ,gēng",
    "三更": "sān,gēng",
    "更生": "gēng,shēng",
    "脖颈": "bó,gěng",
    "提供": "tí,gōng",
    "供销": "gōng,xiāo",
    "口供": "kǒu,gòng",
    "翻供": "fān,gòng",
    "上供": "shàng,gòng",
    "勾当": "gòu,dàng",
    "估衣": "gù,yī",
    "骨碌": "gū,lu",
    "骨朵": "gū,duǒ",
    "冠心病": "guān,xīn,bìng",
    "秦桧": "qín,guì",
    "哈达": "hǎ,dá",
    "哈什蚂": "hà,shí,mǎ",
    "可汗": "kè,hán",
    "巷道": "hàng,dào",
    "寒号": "hán,hào",
    "唱和": "chàng,hè",
    "附和": "fù,hè",
    "曲高和寡": "qǔ,gāo,hè,guǎ",
    "搀和": "chān,huo",
    "搅合": "jiǎo,hé",
    "暖和": "nuǎn,huo",
    "热和": "rè,huo",
    "软和": "ruǎn,huo",
    "一丘之貉": "yī,qiū,zhī,hé",
    "貉绒": "háo,róng",
    "貉子": "háo,zi",
    "喝彩": "hè,cǎi",
    "喝道": "hè,dào",
    "喝令": "hè,lìng",
    "喝止": "hè,zhǐ",
    "呼幺喝六": "hū,yāo,hè,liù",
    "蛮横": "mán,hèng",
    "横财": "hèng,cái",
    "饥荒": "jī,huāng",
    "奇数": "jī,shù",
    "通缉": "tōng,jī",
    "侦缉": "zhēn,jī",
    "茶几": "chá,jī",
    "条几": "tiáo,jī",
    "雪茄": "xuě,jiā",
    "夹带": "jiā,dài",
    "夹道": "jiā,dào",
    "间道": "jiàn,dào",
    "间谍": "jiàn,dié",
    "间断": "jiàn,duàn",
    "间或": "jiàn,huò",
    "间接": "jiàn,jiē",
    "间距": "jiàn,jù",
    "间隙": "jiàn,xì",
    "挑拨离间": "tiǎo,bō,lí,jiàn",
    "味同嚼蜡": "wèi,tóng,jiáo,là",
    "咬文嚼字": "yǎo,wén,jiáo,zì",
    "咀嚼": "jǔ,jué",
    "侥幸": "jiǎo,xìng",
    "角斗": "jué,dòu",
    "口觉": "kǒu,jué",
    "主角": "zhǔ,jué",
    "配角": "pèi,jué",
    "角力": "jué,lì",
    "围剿": "wéi,jiǎo",
    "剿说": "chāo,shuō",
    "剿袭": "chāo,xí",
    "校勘": "jiào,kān",
    "校样": "jiào,yàng",
    "校正": "jiào,zhèng",
    "校对": "jiào,duì",
    "校订": "jiào,dìng",
    "结巴": "jiē,bā",
    "结实": "jiē,shi",
    "芥菜": "jiè,cài",
    "芥末": "jiè,mò",
    "芥蓝菜": "gài,lán,cài",
    "刚劲": "gāng,jìng",
    "强劲": "qiáng,jìng",
    "劲敌": "jìng,dí",
    "疾风劲草": "jí,fēng,jìng,cǎo",
    "矩形": "jǔ,xíng",
    "规矩": "guī,ju",
    "龟裂": "jūn,liè",
    "卡子": "qiǎ,zi",
    "关卡": "guān,qiǎ",
    "看管": "kān,guǎn",
    "看护": "kān,hù",
    "看守": "kān,shǒu",
    "看门": "kān,mén",
    "坷垃": "kē,lā",
    "贝壳": "bèi,ké",
    "脑壳": "nǎo,ké",
    "驳壳枪": "bó,ké,qiāng",
    "地壳": "dì,qiào",
    "甲壳": "jiǎ,qiào",
    "躯壳": "qū,qiào",
    "空心吃药": "kōng,xīn,chī,yào",
    "空白": "kòng,bái",
    "钻空": "zuān,kòng",
    "溃烂": "kuì,làn",
    "溃脓": "huì,nóng",
    "烙印": "lào,yìn",
    "烙铁": "lào,tiě",
    "烙饼": "lào,bǐng",
    "炮烙": "páo,luò",
    "勒逼": "lè,bī",
    "勒令": "lè,lìng",
    "勒派": "lè,pài",
    "勒索": "lè,suǒ",
    "悬崖勒马": "xuán,yá,lè,mǎ",
    "擂台": "lèi,tái",
    "打擂": "dǎ,lèi",
    "累赘": "léi,zhuì",
    "带累": "dài,lěi",
    "累及": "lěi,jí",
    "连累": "lián,lěi",
    "牵累": "qiān,lěi",
    "管窥蠡测": "guǎn,kuī,lí,cè",
    "蠡县": "lǐ,xiàn",
    "范蠡": "fàn,lǐ",
    "打量": "dǎ,liang",
    "掂量": "diān,liang",
    "思量": "sī,liang",
    "估量": "gū,liang",
    "测量": "cè,liáng",
    "衡量": "héng,liáng",
    "量体裁衣": "liáng,tǐ,cái,yī",
    "笼子": "lóng,zi",
    "牢笼": "láo,lóng",
    "笼络": "lǒng,luò",
    "笼统": "lǒng,tǒng",
    "笼罩": "lǒng,zhào",
    "佝偻": "gōu,lóu",
    "伛偻": "yǔ,lǚ",
    "赤身露体": "chì,shēn,lù,tǐ",
    "露天": "lù,tiān",
    "露骨": "lù,gǔ",
    "抛头露面": "pāo,tóu,lù,miàn",
    "露富": "lòu,fù",
    "露苗": "lòu,miáo",
    "露相": "lòu,xiàng",
    "露马脚": "lòu,mǎ,jiǎo",
    "捋胡子": "lǚ,hú,zǐ",
    "绿林": "lù,lín",
    "鸭绿江": "yā,lù,jiāng",
    "络腮": "luò,sāi",
    "落膘": "luò,biāo",
    "落花生": "luò,huā,shēng",
    "着落": "zhuó,luò",
    "落价": "lào,jià",
    "落色": "lào,shǎi",
    "落枕": "lào,zhěn",
    "落炕": "lào,kàng",
    "落子": "lào,zǐ",
    "丢三落四": "diū,sān,là,sì",
    "瓜蔓": "guā,wàn",
    "蔓延": "màn,yán",
    "不蔓不枝": "bù,màn,bù,zhī",
    "压蔓": "yā,wàn",
    "流氓": "liú,máng",
    "秘鲁": "bì,lǔ",
    "靡费": "mí,fèi",
    "风靡": "fēng,mǐ",
    "萎靡": "wěi,mǐ",
    "披靡": "pī,mǐ",
    "泌阳": "bì,yáng",
    "模子": "mú,zǐ",
    "模具": "mú,jù",
    "模样": "mú,yàng",
    "困难": "kùn,nán",
    "难兄难弟": "nàn,xiōng,nàn,dì",
    "排忧解难": "pái,yōu,jiě,nán",
    "发难": "fā,nàn",
    "刁难": "diāo,nàn",
    "责难": "zé,nàn",
    "尿脬": "suī,pāo",
    "率领": "shuài,lǐng",
    "草率": "cǎo,shuài",
    "坦率": "tǎn,shuài",
    "出没": "chū,mò",
    "没落": "mò,luò",
    "出没无常": "chū,mò,wú,cháng",
    "没收": "mò,shōu",
    "宁可": "nìng,kě",
    "宁愿": "nìng,yuàn",
    "安宁": "ān,níng",
    "里弄": "lǐ,lòng",
    "弄堂": "lòng,táng",
    "疟疾": "nüè,jí",
    "发疟子": "fā,yào,zǐ",
    "婀娜": "ē,nuó",
    "袅娜": "niǎo,nuó",
    "排子车": "pǎi,zǐ,chē",
    "迫击炮": "pǎi,jī,pào",
    "心宽体胖": "xīn,kuān,tǐ,pán",
    "喷嚏": "pēn,tì",
    "喷香": "pèn,xiāng",
    "嚏喷": "tì,pen",
    "唱片儿": "chàng,piān,er",
    "画片儿": "huà,piān,er",
    "相片儿": "xiàng,piān,er",
    "影片儿": "yǐng,piān,er",
    "仆从": "pú,cóng",
    "朴刀": "pō,dāo",
    "朴硝": "pò,xiāo",
    "厚朴": "hòu,pò",
    "曝光": "bào,guāng",
    "蹊跷": "qī,qiāo",
    "荨麻": "xún,má",
    "打哈欠": "dǎ,hā,qiàn",
    "勉强": "miǎn,qiǎng",
    "牵强": "qiān,qiǎng",
    "强词夺理": "qiǎng,cí,duó,lǐ",
    "强迫": "qiǎng,pò",
    "强颜欢笑": "qiǎng,yán,huān,xiào",
    "倔强": "jué,jiàng",
    "翘首": "qiáo,shǒu",
    "翘楚": "qiáo,chǔ",
    "连翘": "lián,qiáo",
    "亲家": "qìng,jiā",
    "大曲": "dà,qū",
    "红曲": "hóng,qǔ",
    "苣荬菜": "qǔ,mǎi,cài",
    "懒散": "lǎn,sǎn",
    "零散": "líng,sǎn",
    "散漫": "sǎn,màn",
    "哭丧": "kū,sang",
    "丧事": "sāng,shì",
    "扫兴": "sǎo,xìng",
    "扫帚": "sào,zhǒu",
    "色子": "shǎi,zǐ",
    "活塞": "huó,sāi",
    "瓶塞": "píng,sāi",
    "煞尾": "shā,wěi",
    "煞白": "shà,bái",
    "厦门": "xià,mén",
    "紫衫": "zǐ,shān",
    "红杉": "hóng,shān",
    "水杉": "shuǐ,shān",
    "杉木": "shā,mù",
    "苫布": "shàn,bù",
    "草苫": "cǎo,shān",
    "宿舍": "sù,shè",
    "什么": "shén,me",
    "桑葚": "sāng,shèn",
    "桑葚儿": "sāng,rèn,er",
    "似的": "shì,de",
    "钥匙": "yào,shi",
    "游说": "yóu,shuì",
    "说服": "shuì,fú",
    "数见不鲜": "shuò,jiàn,bù,xiān",
    "不遂": "bù,suí",
    "毛遂自荐": "máo,suí,zì,jiàn",
    "半身不遂": "bàn,shēn,bù,suí",
    "莎草": "suō,cǎo",
    "缩砂密": "sù,shā,mì",
    "重沓": "chóng,tà",
    "疲沓": "pí,ta",
    "妥帖": "tuǒ,tiē",
    "服服帖帖": "fú,fu,tiē,tiē",
    "俯首帖耳": "fǔ,shǒu,tiē,ěr",
    "请帖": "qǐng,tiě",
    "字帖儿": "zì,tiě,ér",
    "字帖": "zì,tiè",
    "碑帖": "bēi,tiè",
    "瓦刀": "wà,dāo",
    "圩子": "wéi,zǐ",
    "委靡": "wěi,mǐ",
    "尾巴": "wěi,bā",
    "马尾巴": "mǎ,yǐ,bā",
    "乌拉": "wù,la",
    "屡见不鲜": "lǚ,jiàn,bù,xiān",
    "相机行事": "xiàng,jī,xíng,shì",
    "银行": "yín,háng",
    "内省": "nèi,xǐng",
    "反省": "fǎn,xǐng",
    "省亲": "xǐng,qīn",
    "不省人事": "bù,xǐng,rén,shì",
    "星宿": "xīng,xiù",
    "二十八宿": "èr,shí,bā,xiù",
    "苜蓿": "mù,xu",
    "削减": "xuē,jiǎn",
    "瘦削": "shòu,xuē",
    "切削": "qiē,xiāo",
    "削铅笔": "xiāo,qiān,bǐ",
    "削球": "xiāo,qiú",
    "贫血": "pín,xuè",
    "心血": "xīn,xuè",
    "呕心沥血": "ǒu,xīn,lì,xuè",
    "血泪": "xuè,lèi",
    "狗血喷头": "gǒu,xuè,pēn,tóu",
    "殷红": "yān,hóng",
    "锁钥": "suǒ,yuè",
    "弃甲曳兵": "qì,jiǎ,yè,bīng",
    "摇曳": "yáo,yè",
    "曳光弹": "yè,guāng,dàn",
    "树荫": "shù,yīn",
    "林荫道": "lín,yīn,dào",
    "应届": "yīng,jiè",
    "应许": "yīng,xǔ",
    "应承": "yìng,chéng",
    "应付": "yìng,fù",
    "应声": "yīng,shēng",
    "应时": "yìng,shí",
    "应验": "yìng,yàn",
    "应傲": "yìng,ào",
    "应用": "yìng,yòng",
    "应运": "yìng,yùn",
    "应征": "yìng,zhēng",
    "里应外合": "lǐ,yìng,wài,hé",
    "呼吁": "hū,yù",
    "晕倒": "yūn,dǎo",
    "头晕": "tóu,yūn",
    "月晕": "yuè,yùn",
    "血晕": "xiě,yùn",
    "晕车": "yūn,chē",
    "登载": "dēng,zǎi",
    "记载": "jì,zǎi",
    "搭载": "dā,zài",
    "怨声载道": "yuàn,shēng,zài,dào",
    "重载": "chóng,zǎi",
    "转载": "zhuǎn,zǎi",
    "装载": "zhuāng,zài",
    "千载难逢": "qiān,zǎi,nán,féng",
    "载歌载舞": "zài,gē,zài,wǔ",
    "选择": "xuǎn,zé",
    "择不开": "zhái,bù,kāi",
    "择菜": "zhái,cài",
    "择席": "zhái,xí",
    "轧钢": "zhá,gāng",
    "轧辊": "zhá,gǔn",
    "着慌": "zháo,huāng",
    "着急": "zháo,jí",
    "着凉": "zháo,liáng",
    "着忙": "zháo,máng",
    "着水": "zhe,shuǐ",
    "着迷": "zháo,mí",
    "着手": "zhuó,shǒu",
    "着眼": "zhuó,yǎn",
    "着意": "zhuó,yì",
    "着重": "zhuó,zhòng",
    "不着边际": "bù,zhuó,biān,jì",
    "失着": "shī,zhāo",
    "骨殖": "gǔ,shi",
    "中奖": "zhòng,jiǎng",
    "中靶": "zhòng,bǎ",
    "种子": "zhǒng,zi",
    "播种": "bō,zhǒng",
    "种植": "zhòng,zhí",
    "种树": "zhòng,shù",
    "种花": "zhòng,huā",
    "种草": "zhòng,cǎo",
    "压轴": "yā,zhòu",
    "属望": "zhǔ,wàng",
    "土著": "tǔ,zhù",
    "运转": "yùn,zhuǎn",
    "经幢": "jīng,chuáng",
    "钻探": "zuān,tàn",
    "钻孔": "zuān,kǒng",
    "钻床": "zuàn,chuáng",
    "钻杆": "zuàn,gǎn",
    "钻具": "zuàn,jù",
    "柞蚕": "zuò,cán",
    "柞绸": "zuò,chóu",
    "柞水": "zhà,shuǐ",
    "作坊": "zuō,fang",
    "传记": "zhuàn,jì",
    "水浒传": "shuǐ,hǔ,zhuàn",
    "传说": "chuán,shuō",
    "传闻": "chuán,wén",
    "传问": "chuán,wèn",
    "传承": "chuán,chéng",
    "左传": "zuǒ,zhuàn",
    "转身": "zhuǎn,shēn",
    "转动": "zhuàn,dòng",
    "转速": "zhuàn,sù",
    "背包": "bēi,bāo",
    "投奔": "tóu,bèn",
    "扁担": "biǎn,dàn",
    "扁舟": "piān,zhōu",
    "便宜": "pián,yi",
    "便宜行事": "biàn,yí,xíng,shì",
    "古刹": "gǔ,chà",
    "刹车": "shā,chē",
    "禅让": "shàn,ràng",
    "封禅": "fēng,shàn",
    "称呼": "chēng,hū",
    "称道": "chēng,dào",
    "伺候": "cì,hòu",
    "攒动": "cuán,dòng",
    "攒射": "cuán,shè",
    "积攒": "jī,zǎn",
    "单于": "chán,yú",
    "提溜": "dī,liū",
    "目的": "mù,dì",
    "粮囤": "liáng,dùn",
    "囤积": "tún,jī",
    "更换": "gēng,huàn",
    "更事": "gēng,shì",
    "枸橘": "gōu,jú",
    "枸杞": "gǒu,qǐ",
    "吐谷浑": "tǔ,yù,hún",
    "大汗": "dà,hán",
    "引吭高歌": "yǐn,háng,gāo,gē",
    "吭声": "kēng,shēng",
    "和面": "huó,miàn",
    "和泥": "huó,ní",
    "和药": "huò,yào",
    "会计": "kuài,jì",
    "财会": "cái,kuài",
    "哄堂": "hōng,táng",
    "哄骗": "hǒng,piàn",
    "起哄": "qǐ,hòng",
    "豁口": "huō,kǒu",
    "奇偶": "jī,ǒu",
    "几案": "jī,àn",
    "茄子": "qié,zi",
    "将校": "jiàng,xiào",
    "将兵": "jiàng,bīng",
    "僬侥": "jiāo,yáo",
    "龟兹": "qiū,cí",
    "苤蓝": "piě,lan",
    "勒紧": "lēi,jǐn",
    "脉脉": "mò,mò",
    "埋怨": "mán,yuàn",
    "悄然": "qiǎo,rán",
    "悄寂": "qiǎo,jì",
    "切磋": "qiē,cuō",
    "切割": "qiē,gē",
    "弯曲": "wān,qū",
    "曲调": "qǔ,diào",
    "曲艺": "qǔ,yì",
    "曲牌": "qǔ,pái",
    "堵塞": "dǔ,sè",
    "阻塞": "zǔ,sè",
    "塞翁失马": "sài,wēng,shī,mǎ",
    "边塞": "biān,sài",
    "塞外": "sài,wài",
    "折本": "shé,běn",
    "什物": "shí,wù",
    "什锦": "shí,jǐn",
    "标识": "biāo,zhì",
    "博闻强识": "bó,wén,qiáng,zhì",
    "相似": "xiāng,sì",
    "说客": "shuì,kè",
    "数落": "shǔ,luò",
    "沓子": "tà,zǐ",
    "调皮": "tiáo,pí",
    "调换": "diào,huàn",
    "拓本": "tà,běn",
    "拓片": "tà,piàn",
    "尉迟": "yù,chí",
    "尉犁": "yù,lí",
    "鲜见": "xiǎn,jiàn",
    "行伍": "háng,wǔ",
    "行市": "háng,shì",
    "殷殷": "yǐn,yǐn",
    "佣金": "yòng,jīn",
    "佣钱": "yòng,qián",
    "熨帖": "yù,tiē",
    "熨烫": "yùn,tàng",
    "参与": "cān,yù",
    "吁求": "yù,qiú",
    "耕种": "gēng,zhòng",
    "属文": "zhǔ,wén",
    "属意": "zhǔ,yì",
    "正月": "zhēng,yuè",
    "正旦": "zhēng,dàn",
    "丽水": "lí,shuǐ",
    "台州": "tāi,zhōu",
    "作为": "zuò,wéi",
    "成为": "chéng,wéi",
    "为难": "wéi,nán"
}, _defineProperty(_mutil_pinyin_dict, "\u8F67\u94A2", "zhá,gāng"), _defineProperty(_mutil_pinyin_dict, "咽喉", "yān,hóu"), _defineProperty(_mutil_pinyin_dict, "呜咽", "wū,yè"), _defineProperty(_mutil_pinyin_dict, "哽咽", "gěng,yè"), _defineProperty(_mutil_pinyin_dict, "鲜为人知", "xiǎn,wéi,rén,zhī"), _defineProperty(_mutil_pinyin_dict, "羽扇纶巾", "yǔ,shàn,guān,jīn"), _defineProperty(_mutil_pinyin_dict, "惟妙惟肖", "wéi,miào,wéi,xiào"), _defineProperty(_mutil_pinyin_dict, "一唱一和", "yī,chàng,yī,hè"), _defineProperty(_mutil_pinyin_dict, "寡廉鲜耻", "guǎ,lián,xiǎn,chǐ"), _defineProperty(_mutil_pinyin_dict, "自怨自艾", "zì,yuàn,zì,yì"), _defineProperty(_mutil_pinyin_dict, "歃血为盟", "shà,xuè,wéi,méng"), _defineProperty(_mutil_pinyin_dict, "揠苗助长", "yà,miáo,zhù,zhǎng"), _defineProperty(_mutil_pinyin_dict, "各奔前程", "gè,bèn,qián,chéng"), _defineProperty(_mutil_pinyin_dict, "创巨痛深", "chuāng,jù,tòng,shēn"), _defineProperty(_mutil_pinyin_dict, "大而无当", "dà,ér,wú,dàng"), _defineProperty(_mutil_pinyin_dict, "大腹便便", "dà,fù,pián,pián"), _defineProperty(_mutil_pinyin_dict, "箪食壶浆", "dān,sì,hú,jiāng"), _defineProperty(_mutil_pinyin_dict, "刀耕火种", "dāo,gēng,huǒ,zhòng"), _defineProperty(_mutil_pinyin_dict, "等量齐观", "děng,liàng,qí,guān"), _defineProperty(_mutil_pinyin_dict, "法家拂士", "fǎ,jiā,bì,shì"), _defineProperty(_mutil_pinyin_dict, "飞来横祸", "fēi,lái,hèng,huò"), _defineProperty(_mutil_pinyin_dict, "封妻荫子", "fēng,qī,yìn,zǐ"), _defineProperty(_mutil_pinyin_dict, "好吃好喝", "hào,chī,hào,hē"), _defineProperty(_mutil_pinyin_dict, "好吃懒做", "hào,chī,lǎn,zuò"), _defineProperty(_mutil_pinyin_dict, "好吹牛", "hào,chuī,niú"), _defineProperty(_mutil_pinyin_dict, "好大喜功", "hào,dà,xǐ,gōng"), _defineProperty(_mutil_pinyin_dict, "好动", "hào,dòng"), _defineProperty(_mutil_pinyin_dict, "好学", "hào,xué"), _defineProperty(_mutil_pinyin_dict, "好好学习", "hǎo,hǎo,xué,xí"), _defineProperty(_mutil_pinyin_dict, "好高骛远", "hào,gāo,wù,yuǎn"), _defineProperty(_mutil_pinyin_dict, "好古", "hào,gǔ"), _defineProperty(_mutil_pinyin_dict, "好管闲事", "hào,guǎn,xián,shì"), _defineProperty(_mutil_pinyin_dict, "好客", "hào,kè"), _defineProperty(_mutil_pinyin_dict, "好奇", "hào,qí"), _defineProperty(_mutil_pinyin_dict, "好色", "hào,sè"), _defineProperty(_mutil_pinyin_dict, "好胜", "hào,shèng"), _defineProperty(_mutil_pinyin_dict, "喜好", "xǐ,hào"), _defineProperty(_mutil_pinyin_dict, "厌恶", "yàn,wù"), _defineProperty(_mutil_pinyin_dict, "好逸恶劳", "hào,yì,wù,láo"), _defineProperty(_mutil_pinyin_dict, "公诸同好", "gōng,zhū,tóng,hào"), _defineProperty(_mutil_pinyin_dict, "冠盖相属", "guān,gài,xiāng,zhǔ"), _defineProperty(_mutil_pinyin_dict, "荷枪实弹", "hè,qiāng,shí,tán"), _defineProperty(_mutil_pinyin_dict, "哭天抢地", "kū,tiān,qiāng,dì"), _defineProperty(_mutil_pinyin_dict, "患难与共", "huàn,nàn,yǔ,gòng"), _defineProperty(_mutil_pinyin_dict, "吉人天相", "jí,rén,tiān,xiàng"), _defineProperty(_mutil_pinyin_dict, "济济一堂", "jǐ,jǐ,yī,táng"), _defineProperty(_mutil_pinyin_dict, "间不容发", "jiān,bù,róng,fà"), _defineProperty(_mutil_pinyin_dict, "教学相长", "jiào,xué,xiāng,zhǎng"), _defineProperty(_mutil_pinyin_dict, "令人发指", "lìng,rén,fà,zhǐ"), _defineProperty(_mutil_pinyin_dict, "深恶痛疾", "shēn,wù,tòng,jí"), _defineProperty(_mutil_pinyin_dict, "拾级而上", "shè,jí,ér,shàng"), _defineProperty(_mutil_pinyin_dict, "敷衍塞责", "fū,yǎn,sè,zé"), _defineProperty(_mutil_pinyin_dict, "否极泰来", "pǐ,jí,tài,lái"), _defineProperty(_mutil_pinyin_dict, "呱呱坠地", "gū,gū,zhuì,dì"), _defineProperty(_mutil_pinyin_dict, "直言贾祸", "zhí,yán,gǔ,huò"), _defineProperty(_mutil_pinyin_dict, "图穷匕见", "tú,qióng,bǐ,xiàn"), _defineProperty(_mutil_pinyin_dict, "虚与委蛇", "xū,yǔ,wēi,yí"), _defineProperty(_mutil_pinyin_dict, "力能扛鼎", "lì,néng,gāng,dǐng"), _defineProperty(_mutil_pinyin_dict, "如法炮制", "rú,fǎ,páo,zhì"), _defineProperty(_mutil_pinyin_dict, "泥古不化", "nì,gǔ,bù,huà"), _defineProperty(_mutil_pinyin_dict, "重庆", "chóng,qìng"), _defineProperty(_mutil_pinyin_dict, "柏林", "bó,lín"), _defineProperty(_mutil_pinyin_dict, "并州", "bīng,zhōu"), _defineProperty(_mutil_pinyin_dict, "吐蕃", "tǔ,bō"), _defineProperty(_mutil_pinyin_dict, "大埔", "dà,bù"), _defineProperty(_mutil_pinyin_dict, "黄埔", "huáng,pǔ"), _defineProperty(_mutil_pinyin_dict, "宝坻", "bǎo,dǐ"), _defineProperty(_mutil_pinyin_dict, "白纸坊", "bái,zhǐ,fāng"), _defineProperty(_mutil_pinyin_dict, "东阿", "dōng,ē"), _defineProperty(_mutil_pinyin_dict, "东莞", "dōng,guǎn"), _defineProperty(_mutil_pinyin_dict, "涡河", "guō,hé"), _defineProperty(_mutil_pinyin_dict, "镐京", "hào,jīng"), _defineProperty(_mutil_pinyin_dict, "华山", "huà,shān"), _defineProperty(_mutil_pinyin_dict, "济南", "jǐ,nán"), _defineProperty(_mutil_pinyin_dict, "六安", "lù,ān"), _defineProperty(_mutil_pinyin_dict, "渑池", "miǎn,chí"), _defineProperty(_mutil_pinyin_dict, "天姥山", "tiān,mǔ,shān"), _defineProperty(_mutil_pinyin_dict, "中牟", "zhōng,mù"), _defineProperty(_mutil_pinyin_dict, "蔚县", "yù,xiàn"), _defineProperty(_mutil_pinyin_dict, "浒墅关", "xǔ,shù,guān"), _defineProperty(_mutil_pinyin_dict, "莘庄", "xīn,zhuāng"), _defineProperty(_mutil_pinyin_dict, "监利", "jiàn,lì"), _defineProperty(_mutil_pinyin_dict, "歙县", "shè,xiàn"), _defineProperty(_mutil_pinyin_dict, "燕山", "yān,shān"), _defineProperty(_mutil_pinyin_dict, "处方", "chǔ,fāng"), _defineProperty(_mutil_pinyin_dict, "扒手", "pá,shǒu"), _defineProperty(_mutil_pinyin_dict, "扒草", "pá,cǎo"), _defineProperty(_mutil_pinyin_dict, "数据", "shù,jù"), _defineProperty(_mutil_pinyin_dict, "重新", "chóng,xīn"), _defineProperty(_mutil_pinyin_dict, "无数", "wú,shù"), _defineProperty(_mutil_pinyin_dict, "成都", "chéng,dū"), _defineProperty(_mutil_pinyin_dict, "重来", "chóng,lái"), _defineProperty(_mutil_pinyin_dict, "重复", "chóng,fù"), _defineProperty(_mutil_pinyin_dict, "重申", "chóng,shēn"), _defineProperty(_mutil_pinyin_dict, "重阳", "chóng,yáng"), _defineProperty(_mutil_pinyin_dict, "重逢", "chóng,féng"), _defineProperty(_mutil_pinyin_dict, "\u91CD\u6C93", "chóng,tà"), _defineProperty(_mutil_pinyin_dict, "重叠", "chóng,dié"), _defineProperty(_mutil_pinyin_dict, "重霄", "chóng,xiāo"), _defineProperty(_mutil_pinyin_dict, "重唱", "chóng,chàng"), _defineProperty(_mutil_pinyin_dict, "重洋", "chóng,yáng"), _defineProperty(_mutil_pinyin_dict, "重峦叠嶂", "chóng,luán,dié,zhàng"), _defineProperty(_mutil_pinyin_dict, "成长", "chéng,zhǎng"), _defineProperty(_mutil_pinyin_dict, "膀胱", "páng,guāng"), _defineProperty(_mutil_pinyin_dict, "膀肿", "pāng,zhǒng"), _defineProperty(_mutil_pinyin_dict, "膀胱区疼痛", "páng,guāng,qū,téng,tòng"), _defineProperty(_mutil_pinyin_dict, "膀胱镜", "páng,guāng,jìng"), _defineProperty(_mutil_pinyin_dict, "洪洞", "hóng,dòng"), _defineProperty(_mutil_pinyin_dict, "一撮儿盐", "yīcuōryán"), _defineProperty(_mutil_pinyin_dict, "一撮盐", "yīcuōyán"), _defineProperty(_mutil_pinyin_dict, "一撮毛", "yīzuǒmáo"), _defineProperty(_mutil_pinyin_dict, "枪杆", "qiānggǎn"), _defineProperty(_mutil_pinyin_dict, "烟杆", "yāngǎn"), _defineProperty(_mutil_pinyin_dict, "东涌", "dōngchōng"), _defineProperty(_mutil_pinyin_dict, "西涌", "xīchōng"), _defineProperty(_mutil_pinyin_dict, "东西涌", "dōngxīchōng"), _defineProperty(_mutil_pinyin_dict, "霞涌", "xiáchōng"), _defineProperty(_mutil_pinyin_dict, "葵涌", "kuíchōng"), _mutil_pinyin_dict);